export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const DEV_SOCKET_URL = process.env.REACT_APP_DEV_SOCKET_URL;
export const VERSION = process.env.REACT_APP_VERSION;
export const DATE_FORMAT = "YYYY-MMM-DD HH:mm";